import { Product } from '@/creditflowresearch/domain/Product';
import { AbsProduct } from '@/creditflowresearch/domain/Product';

const getProductPrefixForTitle = (
  productIds: string[],
  isShowAbs: boolean = false,
  separator: string = ' ',
): string => {
  if (productIds.length === 1) {
    const [productId] = productIds;

    if (Product.isOfType(productId, AbsProduct.TYPE) && !isShowAbs) {
      return '';
    }

    const abbreviation = Product.getAbbreviation(productId);
    return abbreviation ? abbreviation + separator : '';
  }

  return '';
};

export default getProductPrefixForTitle;
